<template>
    <div>

        <Card>
            <p slot="title"> List Piutang Manual</p>
            <div>
                <Card>
                    <ButtonGroup>
                        <Button type="primary" size="large" @click="changeType('date')">
                            <Icon type="ios-arrow-back"></Icon>
                            Per Tanggal
                        </Button>
                        <Button type="primary" size="large" @click="changeType('month')">
                            Per Bulan
                            <Icon type="ios-arrow-forward"></Icon>
                        </Button>
                    </ButtonGroup>
                    <transition name="move-right">
                        <Row type="flex" style="margin: 12px 0" v-show="isDate">
                            <Col span="8">
                            <ButtonGroup class="custom-group-parent">
                                <Button class="custom-group">Tanggal Transaksi</Button>
                                <Date-picker v-model="transactionDate" style="width: 138px;" type="daterange"
                                    format="yyyy-MM-dd">
                                </Date-picker>
                            </ButtonGroup>
                            </Col>

                            <Col span="6">
                            <ButtonGroup class="custom-group-parent">
                                <Button class="custom-group">Branch</Button>
                                <Select v-model="branchSelected" name="branchSelected" style="width: 138px;" clearable>
                                    <Option v-for="type in branchList" :value="type.value" :key="type.value">
                                        {{ type.label }}
                                    </Option>
                                </Select>
                            </ButtonGroup>
                            </Col>

                            <Button type="primary" :loading="isLoadingReceivableList"
                                :disabled="transactionDate[0] == ''" @click="getAllReceivableManual('date')"
                                icon="ios-search" style="float: right;">
                                <span v-if="!isLoadingReceivableList">Cari</span>
                                <span v-else>Wait.....</span>
                            </Button>

                            <Col span="1">
                            <Spin size="large" v-show="isLoadingReceivableList"></Spin>
                            </Col>
                        </Row>
                    </transition>

                    <transition name="move-left">
                        <Row type="flex" style="margin: 12px 0" v-show="isMonth">
                            <Col span="8">
                            <div>
                                <ButtonGroup class="custom-group-parent">
                                    <Button class="custom-group">Bulan Transaksi</Button>
                                    <Date-picker v-model="transactionDateMonth" style="width: 138px;" type="month"
                                        @on-change="getAllReceivableManual('month')">
                                    </Date-picker>
                                </ButtonGroup>
                            </div>
                            </Col>

                            <Col span="1">
                            <Spin size="large" v-show="isLoadingReceivableList"></Spin>
                            </Col>
                        </Row>
                    </transition>
                    <br />
                    <div v-if="receivableList">
                        <Alert type="success" show-icon v-show="totalReceivables != 0"> Total Piutang = Rp {{
                            totalReceivables | numberFormatted }}</Alert>
                        <Table :columns="tableColumns" :data="receivableList"></Table>
                    </div>
                </Card>
            </div>
        </Card>

        <Modal v-model="isModalDelete" title="Konfirmasi" ok-text="Ya" cancel-text="Tidak"
            @on-cancel="confirmDescription = ''">
            <p>Apakah anda yakin ingin menghapus pembayaran piutang?</p>
            <br />
            <div>
                <i> Ketik <b>{{ formDeleteReceivable.markingHeaderCode }}</b> untuk melanjutkan !</i>
                <Input v-model="formDeleteReceivable.receivableId" style="display: none;"></Input>
                <Input v-model="confirmDescription" />
            </div>

            <div slot="footer">
                <Button type="error" long
                    v-show="(formDeleteReceivable.markingHeaderCode).toUpperCase() == confirmDescription.toUpperCase()"
                    @click="deleteActReceivable">Hapus</Button>
            </div>
        </Modal>


    </div>
</template>

<script>

import { HTTP } from '@/components/http-lib'
import _ from 'lodash'
import { get } from 'lodash';
import moment from 'moment'

const numeral = require('numeral');
var axios = require('axios');

export default {
    data() {
        return {
            transactionDate: [],
            transactionDateMonth: "",
            transactionDateStart: "",
            transactionDateEnd: "",
            isLoadingReceivableList: false,
            isDate: true,
            isMonth: false,
            tableColumns: [
                {
                    type: 'index',
                    width: 80,
                    align: 'center'
                },
                {
                    title: 'Marking',
                    key: 'markingheadercode',
                    type: 'html',
                    sortable: false
                },
                {
                    title: 'Tgl. Transaksi',
                    key: 'transactionDate',
                    type: 'html',
                    sortable: false
                },
                {
                    title: 'Keterangan',
                    key: 'description',
                    width: 300,
                    type: 'html',
                    sortable: false
                },
                {
                    title: 'Jumlah',
                    key: 'debitAmount',
                    align: 'right',
                    sortable: false,
                    cellClassName: {
                        name: 'demo-table-info-cell-name'
                    }
                },
                {
                    title: 'Action',
                    key: 'action',
                    align: 'center',
                    render: (h, params) => {
                        const { row } = params;
                        let isDisabled = false;

                        if (row.filename == null || row.filename == "") {
                            isDisabled = true
                        }

                        return h('div', [
                            h('Button', {
                                props: {
                                    type: 'success',
                                    size: 'small',
                                    disabled: isDisabled,
                                },
                                on: {
                                    click: () => {
                                        this.downloadFile(row.markingheadercode, row.filename)
                                    }
                                }
                            }, 'Download'),
                            h('Button', {
                                props: {
                                    type: "error",
                                    size: 'small',
                                    style: 'marginLeft:5px'
                                },
                                on: {
                                    click: () => {
                                        this.showModalDelete(row);
                                    }
                                }
                            }, "Delete")
                        ]);
                    }
                },
            ],
            receivableList: [],
            isModalDelete: false,
            confirmDescription: '',
            formDeleteReceivable: {
                receivableId: '',
                markingHeaderCode: ''
            },
            totalReceivables: 0,
            branchSelected: '',
            branchList: [],
        }
    },
    methods: {
        changeType: function (type) {
            this.isNotFound = false;

            if (type == "month") {
                this.isMonth = true;
                this.isDate = false;
            } else {
                this.isMonth = false;
                this.isDate = true;
            }
        },
        showDateFormatted: function (stringToFormat) {
            let dateToFormat = moment(stringToFormat, 'YYYY-MM-DD').toDate();
            return moment(dateToFormat).format("DD MMM YYYY")
        },
        getReceivableManual: function (status) {

            if (this.transactionDateStart !== '' || this.transactionDateEnd !== '' || this.transactionDateMonth !== '') {
                if (status == 'date') {
                    let payload = {
                        status: status,
                        transactionDateStart: this.transactionDateStart,
                        transactionDateEnd: this.transactionDateEnd,
                        branchCode: this.branchSelected,
                    }
                    console.info({ payload });
                    return HTTP.post('receivable/manual', payload)
                } else {
                    return HTTP.post('receivable/manual', {
                        status: status,
                        transactionDate: this.transactionDateMonth,
                    })
                }
            }
        },
        getAllReceivableManual: function (status) {
            let parent = this;
            if (this.transactionDate.length > 0) {
                this.transactionDateStart = moment(this.transactionDate[0], 'YYYY-MM-DD').format("YYYY-MM-DD");
                this.transactionDateEnd = moment(this.transactionDate[1], 'YYYY-MM-DD').format("YYYY-MM-DD");
            }

            this.transactionDateMonth = moment(this.transactionDateMonth, 'YYYY-MM-DD').format("YYYY-MM-DD");
            if (this.transactionDate.length > 0 && this.transactionDateMonth == '') {
                return;
            }

            this.isLoadingReceivableList = true;

            axios.all([
                this.getReceivableManual(status)
            ]).then(axios.spread((summaryRes) => {
                let receivableAll = []

                parent.totalReceivables = 0
                _.forEach(summaryRes.data, function (value) {
                    let temp = {
                        receivableId: value.id,
                        markingheaderid: value.marking_header.markingheaderid,
                        markingheadercode: value.marking_header.markingheadercode,
                        transactionDate: value.transactionDate,
                        description: value.description,
                        debitAmount: numeral(value.debitAmount).format('0,0'),
                        filename: value.filename
                    }

                    receivableAll.push(temp);

                    // calculate total receivables
                    parent.totalReceivables += value.debitAmount
                });

                this.receivableList = receivableAll;
                this.isLoadingReceivableList = false;
            }))
                .catch(e => {
                    this.$Notice.error({
                        title: "Error",
                        desc: e,
                        duration: 5
                    });
                });

        },
        downloadFile: function (marking, filename) {
            let payload = {
                marking: marking,
                filename: filename
            }

            console.log({ payload });
            HTTP
                .post('receivable/file/download', payload, { responseType: 'blob' })
                .then(response => {
                    console.log({ response });
                    // window.open(URL.createObjectURL(response.data));

                    let a = document.createElement("a");
                    let url = window.URL.createObjectURL(response.data);

                    document.body.appendChild(a);
                    a.style = "display: none";
                    a.href = url;
                    a.download = filename;
                    a.click();
                    window.URL.revokeObjectURL(url);
                })
                .catch(e => {
                    this.$Notice.error({
                        title: "Error",
                        desc: e,
                        duration: 5
                    });
                })
        },
        showModalDelete: function (row) {

            this.formDeleteReceivable.receivableId = row.receivableId
            this.formDeleteReceivable.markingHeaderCode = row.markingheadercode

            this.isModalDelete = true;
        },
        deleteActReceivable: function () {
            this.$Loading.start();
            const receivableId = this.formDeleteReceivable.receivableId;

            let payload = {
                receivableId: receivableId,
            }

            HTTP
                .post('receivable/manual/delete', payload)
                .then(response => {
                    console.log("post delete response :", response);

                    if (response.data.status == 1) {
                        this.isModalDelete = false;
                        this.$Loading.finish();
                        this.confirmDescription = ''
                        this.$Message.success('Piutang berhasil dihapus !');
                    } else {
                        this.isModalDelete = false;
                        this.$Loading.finish();
                        this.confirmDescription = ''

                        this.$Message.error('Piutang gagal dihapus !');
                    }

                    this.receivableList = this.receivableList.filter(function (value) {
                        return value.receivableId != receivableId
                    })
                })
                .catch(e => {
                    this.confirmDescription = ''
                    this.$Notice.error({
                        title: "Error",
                        desc: e,
                        duration: 5
                    });
                })
        },
        getBranchList: function () {
            let parent = this;
            HTTP
                .get('subbranch')
                .then(response => {
                    console.log({ response });
                    let branchList = []
                    _.forEach(response.data, function (value) {
                        let temp = {
                            value: value.subbranchcode,
                            label: value.subbranchname
                        }
                        branchList.push(temp);
                    });

                    parent.branchList = branchList;
                    console.info(parent.branchList);
                })
                .catch(e => {
                    this.$Notice.error({
                        title: "Error",
                        desc: e,
                        duration: 5
                    });
                })
        }
    },
    mounted() {
        this.getBranchList();
    },
}

</script>



// WEBPACK FOOTER //
// ReceivableAddList.vue?9c02cec2